module.exports = __webpack_public_path__ + "static/media/65.f3acc246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/65.jpg
// module id = 625
// module chunks = 0